// extracted by mini-css-extract-plugin
export default {"helpIcon":"StrategyDescription_helpIcon_F0UqF","policyPopup":"StrategyDescription_policyPopup_jpXF7","policyContent":"StrategyDescription_policyContent_wUz3M"};